import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=195dc9c9"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
import style0 from "./Label.vue?vue&type=style&index=0&id=195dc9c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports